// extracted by mini-css-extract-plugin
module.exports = {"nav":"HeaderNav_nav_39bk2","logo":"HeaderNav_logo__BdnJ","menu":"HeaderNav_menu_34Vax","install":"HeaderNav_install_3-UtK","prompt":"HeaderNav_prompt_6WmYV"};